import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useToken from '../common/helper/usetoken';
import { useSelector } from 'react-redux';

const PublicRoutes = () => {
    const { token } = useToken();
    const main_menu = useSelector((state) => state.menu.items);
    const [routTo, setRoutTo] = useState('');

    useEffect(() => {
        if (main_menu && Array.isArray(main_menu)) {
            const firstRoute = main_menu.find(item => item?.route && typeof item.route === "string");
            if (firstRoute) {
                setRoutTo(`/${firstRoute.route}`);
            }
        }
    }, [main_menu]);

    
      useEffect(() => {
        const script = document.getElementById('c10b159f-c584-4f49-8192-66738e4be615');
        if (script) {
          script.remove();
          window.location.reload();
        }
      },[])

    return token ? <Navigate to={routTo} /> : <Outlet />;
};

export default PublicRoutes;
